export const seasonalDistribution = [
  { id: 1, name: 'resident'},
  { id: 2, name: 'breeding' },
  { id: 3, name: 'non-breeding' },
  { id: 4, name: 'migration' }
]
